import { render, staticRenderFns } from "./upload-popover.vue?vue&type=template&id=658582c9&"
import script from "./upload-popover.vue?vue&type=script&lang=js&"
export * from "./upload-popover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports